import { getToken } from "@/api/client";

/**
 * Download a Bearer-protected endpoint to disk. Auth is a token header (not a
 * cookie), so we fetch the bytes ourselves and trigger a download from the blob.
 * Honors the server's Content-Disposition filename, falling back to `fallbackName`.
 */
export async function downloadFile(path: string, fallbackName: string): Promise<void> {
  const token = getToken();
  const res = await fetch(path, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) {
    let msg = "Download mislukt / download failed";
    try {
      msg = JSON.parse(await res.text())?.error?.message || msg;
    } catch {
      /* keep default */
    }
    throw new Error(msg);
  }
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const match = /filename="?([^"]+)"?/.exec(cd);
  const name = match ? match[1] : fallbackName;

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
